import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3c2e20ef"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "school-help-box header-top"
};
const _hoisted_2 = {
  class: "school-help-box_content"
};
const _hoisted_3 = {
  class: "content-4-box common-flex-direction-center"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-title wow fadeInUp"
}, "为您提供", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-des wow fadeInUp",
  "data-wow-delay": "0.2s"
}, "认清自己的定位，明白与商家合作的主要目的是实现共赢", -1));

const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = ["data-wow-delay"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "item-title"
};
const _hoisted_10 = {
  class: "item-des"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_SchoolHeader = _resolveComponent("SchoolHeader");

  const _component_Advantage = _resolveComponent("Advantage");

  const _component_SchoolType = _resolveComponent("SchoolType");

  const _component_EachSideShow = _resolveComponent("EachSideShow");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 4,
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), _createVNode(_component_SchoolHeader, {
    type: 3
  }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_Advantage, {
    type: 2
  }), _createVNode(_component_SchoolType, {
    type: 3
  }), _createVNode(_component_EachSideShow), _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content4List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow rollIn",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.des), 1)], 8, _hoisted_7);
  }), 128))])])]), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"])]);
}